"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function InitializeYourMission() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  return <section data-section-id="172008" id="ready-to-mobilize" className="dark bg-background text-foreground relative flex min-h-[80vh] w-full items-center justify-center overflow-hidden py-24 lg:py-32">
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1615860/img/stark_bw_lion_background.png')] bg-cover bg-center bg-no-repeat grayscale contrast-150 brightness-[0.3] transition-transform duration-10000 ease-linear hover:scale-105" />
        {}
        <div className="absolute inset-0 bg-radial from-transparent via-background/60 to-background/95" />
      </div>

      {}
      <div className="absolute inset-0 z-0 opacity-20 pointer-events-none" style={{
      backgroundImage: "radial-gradient(circle at center, var(--color-primary) 1px, transparent 1px)",
      backgroundSize: "32px 32px"
    }} />

      {}
      <div className="container relative z-10 mx-auto px-4 flex justify-center">
        <div ref={ref} className={`relative flex w-full max-w-5xl flex-col items-center justify-center gap-12 border border-primary/20 bg-secondary/20 p-10 backdrop-blur-xl md:p-20 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {}
          <div className="absolute -top-[1px] -left-[1px] h-8 w-8 border-t-2 border-l-2 border-primary" />
          <div className="absolute -top-[1px] -right-[1px] h-8 w-8 border-t-2 border-r-2 border-primary" />
          <div className="absolute -bottom-[1px] -left-[1px] h-8 w-8 border-b-2 border-l-2 border-primary" />
          <div className="absolute -bottom-[1px] -right-[1px] h-8 w-8 border-b-2 border-r-2 border-primary" />

          {}
          <div className="absolute top-1/2 -left-6 h-[2px] w-12 bg-primary/40 -translate-y-1/2" />
          <div className="absolute top-1/2 -right-6 h-[2px] w-12 bg-primary/40 -translate-y-1/2" />
          <div className="absolute -top-6 left-1/2 h-12 w-[2px] bg-primary/40 -translate-x-1/2" />
          <div className="absolute -bottom-6 left-1/2 h-12 w-[2px] bg-primary/40 -translate-x-1/2" />

          <h2 className="text-center font-sans text-5xl font-black uppercase tracking-tight text-foreground drop-shadow-2xl md:text-7xl lg:text-8xl">
            Ready To Mobilize?
          </h2>

          <Button asChild size="lg" className="group relative h-20 overflow-hidden rounded-sm border-2 border-primary bg-primary px-16 font-mono text-xl font-black uppercase tracking-widest text-primary-foreground shadow-[0_0_50px_rgba(255,115,15,0.3)] transition-all duration-500 hover:bg-primary hover:shadow-[0_0_80px_rgba(255,115,15,0.5)]">
            <Link to="/BookNowPage">
              <span className="relative z-10 flex items-center gap-4">
                Request A Quote
                <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" className="transition-transform duration-300 group-hover:translate-x-2">
                  <path d="M5 12h14" />
                  <path d="m12 5 7 7-7 7" />
                </svg>
              </span>
              {}
              <div className="absolute inset-0 z-0 -translate-x-full bg-gradient-to-r from-transparent via-white/30 to-transparent transition-transform duration-700 group-hover:translate-x-full" />
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}